import { useEffect, useState } from "react";
import "../../styles/modal.css";
import { resolveMediaCarBrand } from "../../services/api";

export default function DocumentEditModal({ open, doc, onClose, onSubmit }) {
  const [form, setForm] = useState({
    name: "",
    isRequired: false,
    isMultiple: false,
  });

  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!doc) return;

    setForm({
      name: doc.name || "",
      isRequired: doc.isRequired || false,
      isMultiple: doc.isMultiple || false,
    });

    if (doc.logo) {
      setPreview(resolveMediaCarBrand(doc.logo));
    }
  }, [doc]);

  useEffect(() => {
    if (open) {
      window.document.body.style.overflow = "hidden";
    }

    return () => {
      window.document.body.style.overflow = "auto";
    };
  }, [open]);

  if (!open || !doc) return null;

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleSubmit(e) {
    e.preventDefault();

    const data = {
      name: form.name,
      isRequired: form.isRequired,
      isMultiple: form.isMultiple,
    };

    onSubmit(doc.id, data);
  }

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <h3>Modifier le type de document</h3>

        <form onSubmit={handleSubmit} className="modalForm">
          <div className="formGrid">
            <Input
              label="Nom du type de document"
              name="name"
              value={form.name}
              required
              onChange={handleChange}
            />

            <div className="formGroup checkboxGroup">
              <label className="checkbox">
                <input
                  type="checkbox"
                  name="isRequired"
                  checked={form.isRequired}
                  onChange={(e) =>
                    setForm({ ...form, isRequired: e.target.checked })
                  }
                />
                <span>Document obligatoire</span>
              </label>
            </div>

            <div className="formGroup checkboxGroup">
              <label className="checkbox">
                <input
                  type="checkbox"
                  name="isMultiple"
                  checked={form.isMultiple}
                  onChange={(e) =>
                    setForm({ ...form, isMultiple: e.target.checked })
                  }
                />
                <span>Autoriser plusieurs fichiers</span>
              </label>
            </div>
          </div>

          <div className="modalActions">
            <button type="button" className="btnGhost" onClick={onClose}>
              Annuler
            </button>
            <button className="btnPrimary">Mettre à jour</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Input({ label, ...props }) {
  return (
    <div className="formGroup">
      <label>{label}</label>
      <input {...props} />
    </div>
  );
}

function FileInput({ label, preview, onChange }) {
  return (
    <div className="fileUpload">
      <label className="fileLabel">{label}</label>

      <label className="fileDrop">
        {preview ? (
          <img src={preview} alt="preview" className="filePreview" />
        ) : (
          <div className="filePlaceholder">
            <span className="fileIcon">📷</span>
            <span>Cliquer pour changer</span>
            <small>PNG, JPG</small>
          </div>
        )}

        <input type="file" accept="image/*" onChange={onChange} hidden />
      </label>
    </div>
  );
}
